
  import { MODAL_LIST_DATA } from '@/constants/modals';
  import has from 'lodash/has';

  export default {
    props: {
      bundle: { type: Object, required: true },
      limit: { type: Number, default: null }
    },
    computed: {
      features () {
        const list = [...this.bundle.plan_features];
        if (this.bundle.broadband && this.bundle.exclusive) {
          list.push({ i18n: 'exclusive', icon: 'search' });
        }
        if (this.bundle.phone) {
          if (this.bundle.calls_anytime_included) {
            list.push({ i18n: 'anytimeLandline', icon: 'phone' });
          } else {
            list.push({ i18n: 'offpeakLandline', icon: 'phone' });
          }
          if (this.bundle.calls_mobile_anytime_included) {
            list.push({ i18n: 'anytimeMobile', icon: 'phone' });
          }
        }
        if (this.bundle.mobile) {
          list.push({ i18n: 'mobileCalls', icon: 'mobile-screen-button', count: this.bundle.mobile_minutes });
          list.push({ i18n: 'mobileData', icon: 'mobile-screen-button', count: this.bundle.mobile_data });

          if (this.bundle.sim_only) {
            list.push({ i18n: 'simOnly', icon: 'sim-card' });
          }
        }
        return this.limit ? list.slice(0, this.limit) : list;
      }
    },
    methods: {
      showChannels () {
        this.$store.commit('modal/PUSH_MODAL', { id: MODAL_LIST_DATA.DIGITAL_CHANNELS, settings: this.bundle });
      },
      title (feature) {
        if (feature.i18n) {
          const key = `${feature.i18n}.title`;
          return has(feature, 'count') ? this.$tc(key, feature.count, { ...this.bundle, ...{ count: feature.count } }) : this.$t(key, this.bundle);
        }
        return feature.title;
      },
      tooltipText (feature) {
        if (feature.i18n) {
          const key = `${feature.i18n}.description`;
          return this.$te(key) ? this.$t(key, this.bundle) : null;
        }
        return feature.description;
      }
    }
  };
